<div *ngIf="isWaitingForResponse" class="loading-overlay">
  <mat-spinner [diameter]="100"></mat-spinner>
</div>

<router-outlet></router-outlet>
